import { FunctionComponent, ReactNode } from "react";

type IconLabelProps = {
  icon: ReactNode;
  text: string | ReactNode | ReactNode[];
  className?: string;
  tooltip?: string | null;
};

export const IconLabel: FunctionComponent<IconLabelProps> = ({
  icon,
  text,
  className,
  tooltip = null,
}: IconLabelProps) => {
  return (
    <div className={`flex items-center gap-1 mb-1 ${className && className}`}>
      <span className="w-5 h-5">{icon}</span>
      <div className="ml-1 toolTipContainer">
        {text}
        {tooltip && <span className="tooltipContent hidden rounded-md">{tooltip}</span>}
      </div>
    </div>
  );
};
